import { render, staticRenderFns } from "./CCRegionSelect.vue?vue&type=template&id=61f7b62a&scoped=true"
import script from "./CCRegionSelect.vue?vue&type=script&lang=js"
export * from "./CCRegionSelect.vue?vue&type=script&lang=js"
import style0 from "./CCRegionSelect.vue?vue&type=style&index=0&id=61f7b62a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f7b62a",
  null
  
)

export default component.exports